import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { UserRole } from '../../model/UserRole';
import { UserManagementService } from '../../services/user-management.service';

@Component({
    selector: 'app-roles-popup',
    templateUrl: './roles-popup.component.html',
    styleUrls: ['./roles-popup.component.scss'],
    standalone: false
})
export class RolesPopupComponent implements OnInit {


  public userRoleForm : UntypedFormGroup
  public otherRolesList: any;
  private userRoles: any;

  constructor(
    private _dialogRef: MatDialogRef<RolesPopupComponent>,   
    private _userManagementService: UserManagementService,
    private _sharedService: SharedService,
    public _fb: UntypedFormBuilder,  
    @Inject(MAT_DIALOG_DATA)
    private _dialogData: any) 
    {        
      this.getOtherRolePrincipals()
      this.getUserRoles(_dialogData.userAbriviation)
      this.initRoleForm(_dialogData.userAbriviation)
    }

  ngOnInit(): void {
  }

  private initRoleForm(userAbriviation : any){
    this.userRoleForm = this._fb.group({
      rolId: [''],
      usuario: [userAbriviation]  
    })

  }
 
  public getOtherRolePrincipals(){
    this._userManagementService.getOtherRolePrincipals().subscribe(response=>{
      this.otherRolesList = response.result    
    })
  } 

  public getUserRoles(abreviacion: String){
    this._userManagementService.getUserRoles(abreviacion).subscribe(response=>{
      this.userRoles = response.result  
    })
  }


  public addUser(uerRole) {
    this._userManagementService.addUserRole(uerRole)
      .subscribe(res => {
        if (res.code === 0 && res.result) {
          this._sharedService.ShowSnackBar('Guardado con éxito');
        } else {
          this._sharedService.ShowSnackBar('Error al crear');
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error');
        console.error(err);
      });
  }

  public submit(){
      //company name selected by user        
      if (this.userRoles.find(t => t['rolId'] == this.userRoleForm.value.rolId )) {
        //restrict adding the same role  
          this._sharedService.ShowSnackBar('Role exsist');
      }else{
        this.addUser(this.userRoleForm.value)
        this.cancel(true)
      }
    
  }

  public cancel(submitSuccess: boolean) {
    //this become null when user click outside the popup without clicking the checkbox
    this._dialogRef.close(submitSuccess == null ? false : submitSuccess);
  }
  

}

